//
// trigger general loading overlay
//

export function appLoader(visibility) {
  let method = visibility ? 'add' : 'remove';

  document.body.classList[method]('loading');
}

//
// Check current location
//

export const isHrefLocation = location => window.location.href.includes(location);

//
// Check if element is on the viewport
//

export function isOnViewport(element) {
  const rect = element.getBoundingClientRect();

  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return vertInView && horInView;
}

//
// handle scroll top button behaviour,
// currently available only on mobile
//

export function handleScrollTop() {
  if (!document.querySelector('.scroll-top-btn')) { return; }

  document.querySelector('.scroll-top-btn').addEventListener('click', event => {
    $('html, body').animate({ scrollTop: $('body').offset().top }, 300)
  });
}

// used in custom IQ test
export function preventDefaultButtonBehaviourAndScrollTop() {
  if (!document.querySelectorAll('.prevent-redirect-and-scroll-top') || !document.querySelector('.default-cta')) { return; }

  document.querySelectorAll('.prevent-redirect-and-scroll-top').forEach((elm) => {
    elm.addEventListener('click', event => {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $('.default-cta').offset().top - (window.outerHeight / 2)
      }, 300)
    });
  });
}

export function setTimestampToCookies() {
  Cookies.set('t_stamp', (new Date()).getTime());
}

export function changeBottomStickyAdPosition() {
  const banner = document.querySelector('.gimmemore-theme.desktop .answer-page .sticky-bottom-banner');
  const contentColumn = document.querySelector('.main.new-web-answer-page');
  const sectionMain = document.querySelector('section.game .main');
  const sectionSidebar = document.querySelector('section.game .sidebar');

  if (!banner) return;

  let bannerLeftMargin = getStickyLeftMargin(sectionMain, sectionSidebar) + 'px';
  let bannerWidth = '732px';
  setStickyInitialPosition(banner, bannerLeftMargin, bannerWidth);

  window.addEventListener('scroll', () => {
    if ((window.innerHeight + window.scrollY) > contentColumn.getBoundingClientRect().bottom + 320) {
      banner.style.position = "absolute";
      banner.style.bottom = "auto";
      setStickyInitialPosition(banner, bannerLeftMargin, bannerWidth);

    } else {
      banner.style.position = "fixed";
      banner.style.bottom = "0";
      setStickyInitialPosition(banner, bannerLeftMargin, bannerWidth);
    }
  });

  window.addEventListener('resize', () => {
    let bannerLeftMargin = getStickyLeftMargin(sectionMain, sectionSidebar) + 'px';
    setStickyInitialPosition(banner, bannerLeftMargin, bannerWidth);
  });
}

function setStickyInitialPosition(banner, leftMargin, width) {
  banner.style.left = leftMargin;
  banner.style.width = width;
}

function getStickyLeftMargin(sectionMain, sectionSidebar) {
  let totalWidth = window.innerWidth;

  if (totalWidth < 1080) return;

  if (sectionMain) {
    totalWidth -= 732;
  }

  if (sectionSidebar) {
    totalWidth -= 308;
  }

  totalWidth = totalWidth / 2 - 10;
  return totalWidth;
}

export function handleStickyFooter() {
  if (!document.querySelector('body.mobile > div.with-sticky-footer')) { return; }

  const delta = 10;
  let currentPosition = window.scrollY;
  document.querySelector('footer').classList.add('sticky');

  if (!!document.querySelector('.sticky-bottom-banner')) {
    document.querySelector('.sticky-bottom-banner').style.zIndex = '20';
  }

  document.addEventListener('scroll', () => {
    if  (window.scrollY > currentPosition) {
      if (Math.floor(window.innerHeight + window.scrollY + delta) >= Math.floor(document.body.clientHeight)) {
        document.querySelector('footer').classList.remove('sticky');
        document.querySelector('footer').classList.add('offset');
        currentPosition = window.scrollY;
      }
    }

    if  (window.scrollY < currentPosition) {
      if (Math.floor(window.innerHeight + window.scrollY + delta) < Math.floor(document.body.clientHeight)) {
        document.querySelector('footer').classList.remove('offset');
        document.querySelector('footer').classList.remove('offset-50');
        document.querySelector('footer').classList.remove('offset-100');
        document.querySelector('footer').classList.add('sticky');
        currentPosition = window.scrollY;
      }
    }

    if (!!document.querySelector('footer').classList.contains('offset') && !!document.querySelector('.sticky-bottom-banner')) {
      if (document.querySelector('.sticky-bottom-banner').offsetHeight >= 50) {
        document.querySelector('footer').classList.add('offset-50');
      }

      if (document.querySelector('.sticky-bottom-banner').offsetHeight >= 100) {
        document.querySelector('footer').classList.add('offset-100');
      }
    }
  });
}